'use strict';

module.exports = /*@ngInject*/
function(
    $q,
    AjaxLocalStorageService,
    ApiConfig,
    InterceptorService,
    ReduxService
) {
    return {
        getStores: function(queryParams) {
            var deferred = $q.defer();
            var req = InterceptorService.buildReq('GET', ApiConfig.misl.stores, '', queryParams);

            // Andy secret sauce fix
            // for preventing OPTIONS pre-flighted requests
            delete req.headers;

             ReduxService.getState()
                .then((state) => {
                    const mislUrbnKey = {
                        urbn_key: state.core.constants.mislConfig.misl_urbn_key
                    }
                    const updatedQueryParams = Object.assign({}, req.params, mislUrbnKey);
                    req.params = updatedQueryParams;

                    if (!AjaxLocalStorageService.isAjaxCached(req, deferred)) {
                         InterceptorService.submitReq(req, deferred);
                    }
                });

            return deferred.promise;
        }
    };
};
